// @ts-nocheck
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useApp, navigate, currentPath as getCurrentPath, LOCATION_EVENT } from '../store/AppStore';
import { useAuth } from '../store/AuthContext';
import { countUnreadInbox } from '../store/inbox';

// ── Inline SVG icons (Lucide-style) ──────────────────────────────────────────
const ICONS: Record<string, string> = {
  Inbox:     '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
  Ticket:    '<path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"/>',
  Users:     '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>',
  Chart:     '<line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>',
  Settings:  '<circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
  Tag:       '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/>',
  Mail:      '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>',
  Bell:      '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/>',
  Paper:     '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
  Server:    '<rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/>',
  Bolt:      '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>',
  ArrowLeft: '<line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/>',
  Search:    '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>',
  Chevron:   '<polyline points="6 9 12 15 18 9"/>',
  ChevronR:  '<polyline points="9 18 15 12 9 6"/>',
  Logout:    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>',
  // INTERNAL space partition
  Lock:      '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>',
  Globe:     '<circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>',
  Layers:    '<polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/>',
  Check:     '<polyline points="20 6 9 17 4 12"/>',
  Sparkle:   '<path d="M12 3l1.9 5.6L19.5 10l-5.6 1.9L12 17l-1.9-5.1L4.5 10l5.6-1.4z"/>',
  Sun:       '<circle cx="12" cy="12" r="4"/><line x1="12" y1="2" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="6.34" y2="6.34"/><line x1="17.66" y1="17.66" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="6.34" y2="17.66"/><line x1="17.66" y1="6.34" x2="19.07" y2="4.93"/>',
  Moon:      '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>',
};

// ── Theme (light / dark) ──────────────────────────────────────────────────────
// Token-driven: flipping the `data-theme` attribute on <html> re-points every
// CSS variable, so the whole app recolors. Persisted to localStorage and applied
// at module load to avoid a flash of the wrong theme on refresh.
export type ThemeMode = 'light' | 'dark';
const THEME_KEY = 'sk-theme';

export function getStoredTheme(): ThemeMode {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === 'dark' ? 'dark' : 'light';
  } catch { return 'light'; }
}

export function applyTheme(mode: ThemeMode) {
  try { document.documentElement.setAttribute('data-theme', mode); } catch {}
  try { localStorage.setItem(THEME_KEY, mode); } catch {}
}

// Tickets owns NO auth screens — login/signup/verify/reset/invite all live on
// the SK Platform (see navigation/platformAuthRedirect). Only the bare root is
// forced light: it's the pre-bounce boot page shown while AuthContext probes the
// session and redirects to the platform auth. The app honors the stored choice
// everywhere else. Mirrors the no-flash <script> in public/index.html and the
// effect in App.web.tsx.
export function isAuthPath(path: string): boolean {
  return path === '/' || path === '';
}

// Theme to apply at boot, before React mounts: light on auth/root paths, the
// stored choice in the app. Path-based because the session isn't known yet.
export function bootTheme(): ThemeMode {
  try {
    if (typeof window !== 'undefined' && isAuthPath(window.location.pathname || '/')) return 'light';
  } catch {}
  return getStoredTheme();
}

// Apply the boot theme as soon as this module loads (before first paint).
if (typeof document !== 'undefined') {
  try { document.documentElement.setAttribute('data-theme', bootTheme()); } catch {}
}

function ThemeToggle() {
  const [mode, setMode] = useState<ThemeMode>(() => getStoredTheme());
  const dark = mode === 'dark';
  const toggle = () => {
    const next: ThemeMode = dark ? 'light' : 'dark';
    setMode(next);
    applyTheme(next);
  };
  return (
    <button
      className="sk-nav-link sk-theme-toggle"
      onClick={toggle}
      role="switch"
      aria-checked={dark}
      aria-label="Toggle dark mode"
    >
      <span className="sk-nav-link-icon"><SvgIcon name={dark ? 'Moon' : 'Sun'} size={15} /></span>
      <span className="sk-nav-link-label">{dark ? 'Dark mode' : 'Light mode'}</span>
      <span className={`sk-theme-switch${dark ? ' is-on' : ''}`} aria-hidden="true">
        <span className="sk-theme-knob" />
      </span>
    </button>
  );
}

export function SvgIcon({ name, size = 15, color = 'currentColor', strokeWidth = 1.8 }: {
  name: string; size?: number; color?: string; strokeWidth?: number;
}) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
      stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round"
      style={{ flexShrink: 0, display: 'block' }}
      dangerouslySetInnerHTML={{ __html: ICONS[name] || ICONS.Bell }} />
  );
}

function NavLink({ icon, label, badge, to, active, onClick }: {
  icon?: React.ReactNode; label: string; badge?: number | string;
  to?: string; active?: boolean; onClick?: () => void;
}) {
  const { toast } = useApp();
  const handle = () => {
    if (onClick) return onClick();
    if (to) return navigate(to);
    toast(`"${label}" is out of scope for this feature.`, 'info');
  };
  return (
    <button className={`sk-nav-link${active ? ' is-active' : ''}`} onClick={handle}>
      {icon && <span className="sk-nav-link-icon">{icon}</span>}
      <span className="sk-nav-link-label">{label}</span>
      {badge != null && badge !== 0 && <span className="sk-nav-badge">{badge}</span>}
    </button>
  );
}

function NavGroup({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <div className="sk-nav-group">
      <span className="sk-nav-group-label">{label}</span>
      {children}
    </div>
  );
}

function SKLogo() {
  return (
    <svg width="22" height="22" viewBox="0 0 32 32" fill="none" style={{ flexShrink: 0 }}>
      <rect width="32" height="32" rx="7" fill="#1C1C2E" />
      <path d="M9 22V10h6.5a3.5 3.5 0 0 1 0 7H12" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23 10v12M18 16h5" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}

// Premium hover card shared by the sidebar footer and the top-bar avatar.
// Shows full name + email, with a Log out action underneath.
function ProfileTip({ className, initials, name, email }: {
  className: string; initials: string; name: string; email: string;
}) {
  const { logout: authLogout } = useAuth();
  const { toast } = useApp();
  const handleLogout = async () => {
    try { await authLogout(); } catch {}
    toast('Signed out.', 'info');
  };
  return (
    <div className={className} role="tooltip">
      <div className="sk-tip-head">
        <div className="sk-user-tip-avatar">{initials}</div>
        <div className="sk-user-tip-body">
          <div className="sk-user-tip-name">{name}</div>
          <div className="sk-user-tip-email">{email}</div>
        </div>
      </div>
      <button className="sk-tip-logout" onClick={handleLogout}>
        <SvgIcon name="Logout" size={14} />
        <span>Log out</span>
      </button>
    </div>
  );
}

function UserFooter() {
  const { user } = useAuth();
  const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase() : '—';
  const name = user ? `${user.first_name} ${user.last_name}`.trim() : 'Account';

  const email = user?.email || 'Support agent';

  return (
    <div className="sk-user-footer">
      <div className="sk-user-avatar">{initials}</div>
      <div className="t-grow">
        <div className="sk-user-name">{name}</div>
        <div className="sk-user-role">{email}</div>
      </div>

      {/* Premium hover card — full name + email + log out. */}
      <ProfileTip className="sk-user-tip" initials={initials} name={name} email={email} />
    </div>
  );
}

// ─── INTERNAL space partition: sidebar space switcher ───
// Holds the active space context. Switching re-scopes every list/filter/search
// to that space. The popover lists ONLY accessible spaces (server-filtered) and
// a "Manage spaces" link. Crossing the PUBLIC/INTERNAL boundary is deliberate —
// it only happens here.
function SpaceCountChip({ stats, internal }: { stats: { total: number; open: number }; internal: boolean }) {
  const live = stats.open > 0;
  return (
    <span
      title={`${stats.open} open / awaiting · ${stats.total} active`}
      style={{
        fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 600,
        minWidth: 20, textAlign: 'center', padding: '1px 6px', borderRadius: 10, flex: 'none',
        background: live ? (internal ? 'var(--internal-soft)' : 'var(--accent-soft)') : 'var(--paper-3)',
        color: live ? (internal ? 'var(--internal-ink)' : 'var(--accent-ink)') : 'var(--ink-4)',
        border: `1px solid ${live ? (internal ? 'var(--internal-line)' : 'var(--accent-line)') : 'var(--line)'}`,
      }}
    >{stats.total}</span>
  );
}

function SpaceSwitcher() {
  const { spaces, activeSpace, activeSpaceId, setActiveSpaceId, spaceTicketStats } = useApp();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);
  // Close when the active space changes (e.g. a mid-session bounce).
  useEffect(() => { setOpen(false); }, [activeSpaceId]);

  if (!spaces || spaces.length === 0) return null;

  const internal = activeSpace?.type === 'INTERNAL';
  const activeStats = activeSpace ? spaceTicketStats(activeSpace.id) : { total: 0, open: 0 };
  const othersNeedAttention = spaces.some(
    (s: any) => activeSpace && s.id !== activeSpace.id && spaceTicketStats(s.id).open > 0,
  );

  return (
    <div ref={ref} style={{ position: 'relative', margin: '12px 0 2px' }}>
      <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.08em', color: 'var(--ink-4)', textTransform: 'uppercase', padding: '0 9px 6px' }}>Space</div>
      <button
        className="sk-space-trigger"
        onClick={() => setOpen(v => !v)}
        style={{
          display: 'flex', alignItems: 'center', gap: 10, width: '100%',
          padding: '9px 11px', borderRadius: 'var(--r-3)', cursor: 'pointer', textAlign: 'left',
          background: internal ? 'var(--internal-soft)' : 'var(--card)',
          border: `1px solid ${internal ? 'var(--internal-line)' : 'var(--line)'}`,
          borderLeft: internal ? '3px solid var(--internal)' : '1px solid var(--line)',
          boxShadow: '0 1px 2px rgba(18,18,38,0.04), 0 4px 12px -8px rgba(18,18,38,0.18)',
          transition: 'box-shadow var(--t-base) var(--ease-out), transform var(--t-base) var(--ease-out)',
        }}
      >
        <span style={{
          width: 28, height: 28, borderRadius: 'var(--r-2)', flex: 'none', display: 'grid', placeItems: 'center',
          background: internal ? 'linear-gradient(140deg, var(--internal), color-mix(in srgb, var(--internal) 70%, #000))' : 'linear-gradient(140deg, #2b2b48, #16162a)',
          color: '#fff',
          boxShadow: '0 3px 8px -3px rgba(18,18,38,0.5), inset 0 1px 0 rgba(255,255,255,0.1)',
        }}>
          <SvgIcon name={internal ? 'Lock' : 'Globe'} size={internal ? 13 : 14} strokeWidth={internal ? 2.2 : 1.9} color="#fff" />
        </span>
        <span style={{ flex: 1, minWidth: 0 }}>
          <span style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: 'var(--ink)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{activeSpace?.name ?? '—'}</span>
          <span style={{ display: 'block', fontSize: 10.5, fontWeight: 500, letterSpacing: '0.02em', color: internal ? 'var(--internal-ink)' : 'var(--ink-3)' }}>
            {activeSpace ? `${activeSpace.type} · ${(activeSpace.key || '').toUpperCase()}` : ''}
          </span>
        </span>
        {activeSpace && <SpaceCountChip stats={activeStats} internal={internal} />}
        <span style={{ position: 'relative', display: 'flex', flex: 'none' }}>
          <SvgIcon name="Chevron" size={13} strokeWidth={1.9} color="var(--ink-4)" />
          {othersNeedAttention && !open && (
            <span title="Other spaces have open tickets" style={{ position: 'absolute', top: -3, right: -3, width: 7, height: 7, borderRadius: 99, background: 'var(--internal)', border: '1.5px solid var(--card)' }} />
          )}
        </span>
      </button>

      {open && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0, marginTop: 6, zIndex: 60,
          background: 'var(--card)', border: '1px solid var(--line)', borderRadius: 'var(--r-3)',
          boxShadow: 'var(--shadow-lg)', padding: 6, animation: 't-slideup 140ms var(--ease-out)',
        }}>
          {spaces.map((s: any) => {
            const isI = s.type === 'INTERNAL';
            const active = activeSpace && s.id === activeSpace.id;
            return (
              <button
                key={s.id}
                onClick={() => { setActiveSpaceId(s.id); setOpen(false); }}
                style={{
                  display: 'flex', alignItems: 'center', gap: 9, width: '100%', padding: '7px 8px',
                  borderRadius: 'var(--r-2)', cursor: 'pointer', textAlign: 'left',
                  background: active ? 'var(--paper-2)' : 'transparent', border: 'none',
                }}
                onMouseEnter={e => { if (!active) (e.currentTarget as HTMLElement).style.background = 'var(--paper-2)'; }}
                onMouseLeave={e => { if (!active) (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
              >
                <span style={{
                  width: 22, height: 22, borderRadius: 'var(--r-1)', flex: 'none', display: 'grid', placeItems: 'center',
                  background: isI ? 'var(--internal)' : 'var(--ink)', color: '#fff',
                }}>
                  <SvgIcon name={isI ? 'Lock' : 'Globe'} size={isI ? 11 : 12} strokeWidth={isI ? 2.2 : 1.9} color="#fff" />
                </span>
                <span style={{ flex: 1, minWidth: 0 }}>
                  <span style={{ display: 'block', fontSize: 12.5, fontWeight: 500, color: 'var(--ink)' }}>{s.name}</span>
                  <span style={{ display: 'block', fontSize: 10.5, color: isI ? 'var(--internal-ink)' : 'var(--ink-3)' }}>{s.type} · {(s.key || '').toUpperCase()}</span>
                </span>
                <SpaceCountChip stats={spaceTicketStats(s.id)} internal={isI} />
                {active && <SvgIcon name="Check" size={13} strokeWidth={2.4} color="var(--ink-3)" />}
              </button>
            );
          })}
          <div style={{ height: 1, background: 'var(--line)', margin: '6px 4px' }} />
          <button
            onClick={() => { navigate('/admin/settings/spaces'); setOpen(false); }}
            style={{
              display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '7px 8px',
              borderRadius: 'var(--r-2)', cursor: 'pointer', textAlign: 'left', background: 'transparent', border: 'none',
              color: 'var(--ink-2)', fontSize: 12.5, fontWeight: 500,
            }}
            onMouseEnter={e => { (e.currentTarget as HTMLElement).style.background = 'var(--paper-2)'; }}
            onMouseLeave={e => { (e.currentTarget as HTMLElement).style.background = 'transparent'; }}
          >
            <SvgIcon name="Layers" size={14} color="var(--ink-3)" /> Manage spaces
          </button>
        </div>
      )}
    </div>
  );
}

// ─── Top-bar focus strip — where is the pending work, right now? ───
// Read-only labels (NOT controls) — crossing the partition stays a deliberate
// act via the sidebar switcher. When everything is cleared it flips to a
// celebratory inbox-zero pill.
function SpaceFocusStrip() {
  const { spaces, spaceTicketStats, activeSpace } = useApp();
  const { user } = useAuth();
  if (!spaces || spaces.length === 0) return null;

  const withOpen = spaces
    .map((s: any) => ({ s, open: spaceTicketStats(s.id).open }))
    .filter((x: any) => x.open > 0);
  const total = withOpen.reduce((n: number, x: any) => n + x.open, 0);
  const firstName = (user?.first_name || '').trim();

  if (total === 0) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8, height: 30, padding: '0 14px', flex: 'none',
        borderRadius: 'var(--r-full)', background: 'var(--success-soft)',
        border: '1px solid var(--success-line)', color: 'var(--success)',
        fontSize: 12.5, fontWeight: 600, whiteSpace: 'nowrap',
      }}>
        <SvgIcon name="Sparkle" size={15} strokeWidth={2} color="var(--success)" />
        <span className="t-spark-host">Inbox zero{firstName ? ` — nice work, ${firstName}!` : ' — nice work!'}</span>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 9, flex: 'none' }} title="Pending work per space · switch space from the sidebar">
      <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.05em', color: 'var(--ink-4)', textTransform: 'uppercase', flex: 'none' }}>Pending</span>
      <div style={{ display: 'flex', gap: 6 }}>
        {withOpen.map(({ s, open }: any) => {
          const isI = s.type === 'INTERNAL';
          const active = activeSpace && s.id === activeSpace.id;
          return (
            <span
              key={s.id}
              title={`${open} pending in ${s.name}${active ? ' · current space' : ''}`}
              style={{
                display: 'flex', alignItems: 'center', gap: 6, height: 26, padding: '0 6px 0 9px', flex: 'none',
                borderRadius: 'var(--r-full)', fontSize: 12, fontWeight: 600,
                background: active ? (isI ? 'var(--internal)' : 'var(--accent)') : (isI ? 'var(--internal-soft)' : 'var(--paper-2)'),
                color: active ? '#fff' : (isI ? 'var(--internal-ink)' : 'var(--ink-2)'),
                border: `1px solid ${active ? 'transparent' : (isI ? 'var(--internal-line)' : 'var(--line)')}`,
              }}
            >
              <SvgIcon name={isI ? 'Lock' : 'Globe'} size={11} strokeWidth={isI ? 2.2 : 1.9} color={active ? '#fff' : (isI ? 'var(--internal-ink)' : 'var(--ink-2)')} />
              <span style={{ fontFamily: 'var(--font-mono)' }}>{(s.key || '').toUpperCase()}</span>
              <span style={{
                minWidth: 16, textAlign: 'center', padding: '0 5px', borderRadius: 10,
                fontFamily: 'var(--font-mono)', fontSize: 11, fontWeight: 700,
                background: active ? 'rgba(255,255,255,.24)' : (isI ? 'var(--internal)' : 'var(--accent)'), color: '#fff',
              }}>{open}</span>
            </span>
          );
        })}
      </div>
    </div>
  );
}

function AppSidebar({ currentPath }: { currentPath: string }) {
  const { tickets, visibleTickets, readInboxIds, toast } = useApp();
  const { org, logout: authLogout } = useAuth();
  const isAdmin = currentPath.startsWith('/admin');
  // Workspace ticket counts re-scope to the active space; the inbox count stays
  // global (the inbox is not space-scoped in V1).
  const scopedTickets = visibleTickets ?? tickets;

  const handleLogout = async () => {
    try { await authLogout(); } catch {}
    toast('Signed out.', 'info');
  };

  // Workspace avatar initials from the business name — fully dynamic, sourced
  // from `org.name` in the GET /v1/me response. Two words → first letter of
  // each ("Usher Media" → "UM"); single word → first two letters ("Softknack"
  // → "SO"). Updates automatically whenever the org is renamed.
  const wsName = org?.name || 'SK Tickets';
  const wsParts = wsName.trim().split(/\s+/).filter(Boolean);
  const wsInitials = (
    wsParts.length >= 2 ? wsParts[0][0] + wsParts[1][0] : wsName.trim().slice(0, 2)
  ).toUpperCase() || 'SK';

  const counts = useMemo(() => ({
    all:     scopedTickets.filter(t => t.status !== 'closed').length,
    open:    scopedTickets.filter(t => t.status === 'open').length,
    pending: scopedTickets.filter(t => t.status === 'pending').length,
    bounced: scopedTickets.filter(t => t.comments.some(c =>
      c.type === 'system-bounce' ||
      (c.delivery && (c.delivery.state === 'bounced' || c.delivery.state === 'partial'))
    )).length,
    // Real unread inbox count — shared with the Inbox screen so they agree.
    inbox:   countUnreadInbox(tickets, readInboxIds),
  }), [scopedTickets, tickets, readInboxIds]);

  const isTickets = currentPath === '/tickets' || currentPath.startsWith('/tickets/');

  return (
    <aside className="sk-sidebar">
      <div className="sk-sidebar-ws-btn" style={{ cursor: 'default' }}>
        <div className="sk-sidebar-ws-logo">{wsInitials}</div>
        <div className="t-grow">
          <div className="sk-sidebar-ws-name">{wsName}</div>
          <div className="sk-sidebar-ws-sub">SK-Tickets</div>
        </div>
      </div>

      <nav className="sk-nav-scroll">
        {!isAdmin ? (
          <>
            <SpaceSwitcher />
            <NavGroup label="Workspace">
              <NavLink icon={<SvgIcon name="Inbox" size={15} />} label="Inbox" badge={counts.inbox || undefined} to="/inbox" active={currentPath === '/inbox'} />
              <NavLink icon={<SvgIcon name="Ticket" size={15} />} label="Tickets" badge={counts.all} to="/tickets" active={isTickets} />
              <NavLink icon={<SvgIcon name="Users" size={15} />} label="Contacts" to="/customers" active={currentPath === '/customers'} />
              <NavLink icon={<SvgIcon name="Chart" size={15} />} label="Reports" to="/reports" active={currentPath === '/reports'} />
            </NavGroup>
            <NavGroup label="Views">
              <NavLink icon={<span className="sk-nav-dot" style={{ background: 'var(--info)' }} />} label="My open" badge={counts.open} to="/tickets/view/open" active={currentPath === '/tickets/view/open'} />
              <NavLink icon={<span className="sk-nav-dot" style={{ background: 'var(--warn)' }} />} label="Awaiting reply" badge={counts.pending} to="/tickets/view/pending" active={currentPath === '/tickets/view/pending'} />
              <NavLink icon={<span className="sk-nav-dot" style={{ background: 'var(--success)' }} />} label="Resolved today" to="/tickets/view/resolved" active={currentPath === '/tickets/view/resolved'} />
              <NavLink icon={<span className="sk-nav-dot" style={{ background: 'var(--danger)' }} />} label="Bounced" badge={counts.bounced || undefined} to="/tickets/view/bounced" active={currentPath === '/tickets/view/bounced'} />
            </NavGroup>
            <NavGroup label="Settings">
              <NavLink icon={<SvgIcon name="Settings" size={15} />} label="Settings" to="/admin/settings/general" active={currentPath.startsWith('/admin')} />
            </NavGroup>
          </>
        ) : (
          <>
            <NavLink icon={<SvgIcon name="ArrowLeft" size={13} />} label="Back to workspace" onClick={() => navigate('/tickets')} />
            <NavGroup label="Account">
              <NavLink icon={<SvgIcon name="Settings" size={15} />} label="General" to="/admin/settings/general" active={currentPath === '/admin/settings/general'} />
              <NavLink icon={<SvgIcon name="Layers" size={15} />} label="Spaces" to="/admin/settings/spaces" active={currentPath.startsWith('/admin/settings/spaces')} />
              <NavLink icon={<SvgIcon name="Users" size={15} />} label="Agents & roles" to="/admin/settings/agents" active={currentPath === '/admin/settings/agents'} />
              <NavLink icon={<SvgIcon name="Tag" size={15} />} label="Tags & fields" to="/admin/settings/tags" active={currentPath === '/admin/settings/tags'} />
            </NavGroup>
            <NavGroup label="Communication">
              <NavLink icon={<SvgIcon name="Mail" size={15} />} label="Email Channel" to="/admin/settings/email-channel" active={currentPath === '/admin/settings/email-channel'} />
              <NavLink icon={<SvgIcon name="Paper" size={15} />} label="Email Templates" to="/admin/settings/email-templates" active={currentPath.startsWith('/admin/settings/email-templates')} />
              <NavLink icon={<SvgIcon name="Bell" size={15} />} label="Notifications" to="/admin/settings/notifications" active={currentPath === '/admin/settings/notifications'} />
            </NavGroup>
            <NavGroup label="Developer">
              <NavLink icon={<SvgIcon name="Server" size={15} />} label="API & webhooks" to="/admin/settings/api" active={currentPath === '/admin/settings/api'} />
              <NavLink icon={<SvgIcon name="Bolt" size={15} />} label="Automations" to="/admin/settings/automations" active={currentPath === '/admin/settings/automations'} />
            </NavGroup>
          </>
        )}
        <NavGroup label="Appearance">
          <ThemeToggle />
        </NavGroup>
        <NavGroup label="Logout">
          <NavLink icon={<SvgIcon name="Logout" size={15} />} label="Log out" onClick={handleLogout} />
        </NavGroup>
      </nav>

      <UserFooter />
    </aside>
  );
}

function TopBarUser() {
  const { user } = useAuth();
  const initials = user ? `${user.first_name?.[0] || ''}${user.last_name?.[0] || ''}`.toUpperCase() : '—';
  const name = user ? `${user.first_name} ${user.last_name}`.trim().toUpperCase() : 'ACCOUNT';
  const email = user?.email || 'Support agent';

  return (
    <div className="sk-topbar-user">
      <span className="sk-topbar-user-name">{name}</span>
      <div className="sk-topbar-avatar">{initials}</div>

      {/* Premium hover card — name + email + log out. */}
      <ProfileTip className="sk-topbar-user-tip" initials={initials} name={name} email={email} />
    </div>
  );
}

function AppTopBar({ crumbs, right, onMenu }: {
  crumbs: Array<{ label: string; to?: string }>;
  right?: React.ReactNode;
  onMenu?: () => void;
}) {
  return (
    <header className="sk-topbar">
      <button className="sk-hamburger" onClick={onMenu} aria-label="Open menu">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>
      <nav className="sk-topbar-crumbs">
        {crumbs.map((c, i) => (
          <React.Fragment key={i}>
            {i > 0 && <span className="sk-topbar-crumb-sep">›</span>}
            {c.to ? (
              <button className="sk-topbar-crumb" onClick={() => navigate(c.to!)}>{c.label}</button>
            ) : (
              <span className={`sk-topbar-crumb${i === crumbs.length - 1 ? ' is-active' : ''}`}>{c.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>
      <div className="t-grow" />
      <SpaceFocusStrip />
      {right}
      <TopBarUser />
    </header>
  );
}

export function ScreenShell({
  crumbs, topRight, children,
}: {
  crumbs?: Array<{ label: string; to?: string }>;
  topRight?: React.ReactNode;
  children: React.ReactNode;
}) {
  const [, tick] = useState(0);
  // Mobile drawer open/close. Navigating always closes it so the drawer never
  // lingers over the page the user just opened.
  const [navOpen, setNavOpen] = useState(false);
  const currentPath = getCurrentPath();
  const { isAssignmentOnly } = useApp();

  useEffect(() => {
    const h = () => { tick(n => n + 1); setNavOpen(false); };
    window.addEventListener('popstate', h);
    window.addEventListener(LOCATION_EVENT, h);
    return () => {
      window.removeEventListener('popstate', h);
      window.removeEventListener(LOCATION_EVENT, h);
    };
  }, []);

  /**
   * SKTICK-DB-001 §2.4 — the assignment-only chrome.
   *
   * The sidebar carries the SPACE SWITCHER, per-space ticket counts, a
   * "Manage spaces" link, reports and customers. For a principal with zero
   * space memberships every one of those is something they must not be shown
   * exists — and the counts come from queries whose totals would describe
   * tickets they cannot read.
   *
   * Gating it here rather than per screen is deliberate: any screen an
   * assignment-only user can reach renders through this shell, so one gate
   * covers all of them and a new screen cannot forget. The ticket detail is
   * the case that matters today — it uses ScreenShell, so without this an
   * outlet manager opening their own ticket would be shown the switcher.
   *
   * `null` means still loading, and is treated as NOT assignment-only so a
   * member never loses their navigation for a frame.
   */
  if (isAssignmentOnly === true) {
    return (
      <div className="sk-app sk-app--bare">
        <div className="sk-main">
          <div className="sk-content">
            {children}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`sk-app${navOpen ? ' sk-nav-open' : ''}`}>
      <div className="sk-nav-backdrop" onClick={() => setNavOpen(false)} />
      <AppSidebar currentPath={currentPath} />
      <div className="sk-main">
        <AppTopBar crumbs={crumbs || [{ label: 'Tickets' }]} right={topRight} onMenu={() => setNavOpen(true)} />
        <div className="sk-content">
          {children}
        </div>
      </div>
    </div>
  );
}
